import { c as _c } from "react/compiler-runtime";
import './nav-card.scss';
import { Skeleton } from '@sola/ark-core/atoms/skeleton/skeleton.tsx';
import { cn } from '@sola/ark-core/utils/helpers.ts';
export const NavCardSkeleton = t0 => {
  const $ = _c(6);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("NavCard w-full flex flex-row", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div><Skeleton width="124px" height="124px" style={{
        aspectRatio: "1 / 1"
      }} className="NavCard__image" /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="w-full flex flex-col gap-snug-xl"><Skeleton height="2rem" width="60%" /><Skeleton height="1rem" width="90%" /><Skeleton height="1rem" width="70%" /><Skeleton height="1rem" width="20%" /></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1) {
    t4 = <div className={t1}>{t2}{t3}</div>;
    $[4] = t1;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};